import { render, staticRenderFns } from "./DashboardReviewsWidget.vue?vue&type=template&id=50c6e141&"
import script from "./DashboardReviewsWidget.vue?vue&type=script&lang=js&"
export * from "./DashboardReviewsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports